export const Work = [
    {
        id: 1,
        name: "Amazon Clone",
        description: "It is a clone of Amazon with features like Payment Proccess using Stripe, You can add items into basket, and Remove items from basket tooo...",
        tags: ["react", "firebase", "react-context-api"],
        demo: "https://clone-52f9c.web.app/",
        github: "https://github.com/MrBlueBird2/amazon-clone"
    },
    {
        id: 2,
        name: "MrBlueBird2.github.io",
        description: "My First Portfolio Website using HTML JS and Bootstrap, This was my first HTML Project!!",
        tags: ["html", "css", "bootstrap"],
        demo: "https://mrbluebird2.github.io",
        github: "https://github.com/MrBlueBird2/mrbluebird2.github.io"
    },
    {
        id: 3,
        name: "Jarvis in Python",
        description: "Jarivs using Python, This jarvis can wikipedia something, open YouTube and many more things!.",
        tags: ["ai", "python", "jarvis"],
        demo: "Unavailable",
        github: "https://github.com/MrBlueBird2/jarvis-in-python"
    },
    {
        id: 4,
        name: "Rock Paper Scissors",
        description: "Simple Rock Paper Scissors Game, I made this game when I was learning Functions and Loops in Python",
        tags: ["rps", "python", "functions"],
        demo: "Unavailable",
        github: "https://github.com/MrBlueBird2/rock-paper-scissors"
    },
    {
        id: 5,
        name: "Todo Flask App",
        description: "This Project is created using Flask and Data Base, A todo list application!!",
        tags: ["database", "flask", "todo"],
        demo: "https://td-app-flask.herokuapp.com",
        github: "https://github.com/MrBlueBird2/jarvis-in-python"
    }
]